// extracted by mini-css-extract-plugin
export default {"card":"index_card__8kMnC","tag":"index_tag__Rlo0G","hidden":"index_hidden__CCSAe","blur-bg":"index_blur-bg__mEUgG"};